// extracted by mini-css-extract-plugin
export var filterIncDec = "_df-0";
export var leftBorder = "_df-1";
export var rightBorder = "_df-2";
export var stringInput = "_df-3";